//userSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
// Function to check if the token has expired
function isTokenExpired(token) {
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const tokenExpiration = decodedToken.exp;
      const currentTime = Math.floor(Date.now() / 1000);
      if (currentTime > tokenExpiration) {
        localStorage.removeItem("user"); // 从 localStorage 移除用户信息
        localStorage.removeItem("token"); // 从 localStorage 移除token
        return null;
      } else return token;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null; // Assume token is expired if there's an error
    }
  }
  return null; // No token found, assume it's expired
}
const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null, // 从 localStorage 加载用户信息
  token: isTokenExpired(localStorage.getItem("token")) || null,
  onlineUser: [],
  socketConnection: null,
};

export const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload; // 设置用户信息
      localStorage.setItem("user", JSON.stringify(action.payload)); // 保存用户信息到 localStorage
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
    logout: (state, action) => {
      state.user = null; // 清除用户信息
      state.token = null; // 清除用户信息
      localStorage.removeItem("user"); // 从 localStorage 移除用户信息
      localStorage.removeItem("token"); // 从 localStorage 移除token
    },
    setOnlineUser: (state, action) => {
      state.onlineUser = action.payload;
    },
    setSocketConnection: (state, action) => {
      state.socketConnection = action.payload;
    },
  },
});

export const { setUser, setToken, logout, setOnlineUser, setSocketConnection } =
  userSlice.actions;

export default userSlice.reducer;
